import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../app/ApiGen';
import { Normalised } from '../../utils/request';
import { UserState } from './types';

const initialState: UserState = {
  loading: false,
  error: undefined,
  current: undefined,
};

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    getCurrentUserAction: (
      state: UserState,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- This is required to pass the ID to the saga
      _: PayloadAction<{ id: string }>,
    ) => ({
      ...state,
      loading: true,
      error: undefined,
    }),
    setCurrentUserAction: (state: UserState, action: PayloadAction<{ user: Normalised<User> }>) => ({
      ...state,
      loading: false,
      error: undefined,
      current: action.payload.user,
    }),
    setUserErrorAction: (state: UserState, action: PayloadAction<{ error: Error }>) => ({
      ...state,
      loading: false,
      error: action.payload.error,
    }),
    clearCurrentUserAction: (state: UserState) => ({
      ...state,
      loading: false,
      error: undefined,
      current: undefined,
    }),
  },
});

export const { actions: userActions, reducer: userReducers } = userSlice;
